<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
     <div class="row mb-2 text-muted">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4>MY APPLICATIONS</h4>
            <hr>
            <span>Application is a logical entity to partition your users and groups. All your users and groups are local and confined to an Application.</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                bordered
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                    <template #cell(name)="row">
                        <div>
                            <a href="/setting" target="_blank" rel="noopener noreferrer"><span @click="row.item.app_id">{{row.item.name}}</span></a>
                        </div>
                    </template>
                    <template #cell(change_app_token)="row">
                        <div>
                            <span class="btn btn-primary rounded-pill btn-sm" @click="row.item.app_id">Change App Token</span>
                        </div>
                    </template>
                    <template #cell(settings)="row">
                        <div class="text-center">
                            <router-link :to="'/settings/'+row.item.app_id"> <b-button variant="info" size="sm" @click="row.item.app_id"> <i class="mdi mdi-cog"></i></b-button></router-link>
                        </div>
                    </template>
                    <template #cell(delete)="row">
                        <div>
                          <b-button variant="danger" size="sm" @click="row.item.app_id"> <i class="bx bx-trash-alt"></i></b-button>
                        </div>
                    </template>
              
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { tableData } from "./dataAdvancedtable";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Application",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      tableData: tableData,
      title: "Application",
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Application",
          active: true
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "app_id", sortable: true },
        { key: "name", sortable: true },
        { key: "app_token", sortable: true },
        { key: "change_app_token", sortable: true },
        { key: "settings", sortable: true },
        { key: "delete", sortable: true ,  class: 'text-center'}
      ]
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>

